import { useEffect, useState } from 'react';
import { api } from '../../api';
import TileCard from '../components/TileCard';

/**
 * Apollo GM §5 — Open Sign Requests. Was a "coming soon" placeholder until
 * the Sign Request bucket went live (Jul 27); now shows real counts from
 * the visibility-scoped bucket-stats endpoint.
 *   Scheduled = date reserved on the calendar
 *   Awaiting  = emergencies / not yet slotted by the Sign Manager
 * File keeps its historical name so dashboard layout wiring is untouched.
 */
export default function SignRequestsPlaceholderTile() {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    let cancelled = false;
    api.getRequestBucketStats({ type: 'sign_request' })
      .then(d => { if (!cancelled) setState({ loading: false, error: null, data: d }); })
      .catch(err => { if (!cancelled) setState({ loading: false, error: err?.message || 'failed', data: null }); });
    return () => { cancelled = true; };
  }, []);

  const byStatus = state.data?.by_status || {};
  const scheduled = byStatus.scheduled || 0;
  const awaiting = byStatus.submitted || 0;
  const completed = byStatus.completed || 0;

  return (
    <TileCard
      title="Open Sign Requests"
      loading={state.loading}
      error={state.error}
      actionHref="/sales/requests/sign_request"
      actionLabel="Sign Requests →"
    >
      <div className="dash-stat-row" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">{scheduled}</div>
          <div className="dash-stat-chip-label">Scheduled</div>
        </div>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value" style={awaiting > 0 ? { color: '#dc2626' } : undefined}>{awaiting}</div>
          <div className="dash-stat-chip-label">Awaiting</div>
        </div>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">{completed}</div>
          <div className="dash-stat-chip-label">Completed</div>
        </div>
      </div>
    </TileCard>
  );
}
